import React from 'react';
import { colors } from '@/globalStyles';

const PolylineComponent = props => {
  const { id, primitiveProps, style, className } = props;
  const { coords, outline_style } = primitiveProps;
  const parsedStyle = JSON.parse(JSON.stringify(style));
  const styles = {
    ...parsedStyle,
    pointerEvents: className === 'decoration' ? 'none' : 'unset',
    fill: 'none',
    ...(!parsedStyle.stroke && { stroke: outline_style && outline_style.enabled && outline_style.color ? outline_style.color : colors.black }),
  };

  return <polyline id={id} points={coords} className={className} style={styles} />;
};

export default PolylineComponent;
